import React from "react"
import styled from "styled-components"

import NpsRatingButton from "./NpsRatingButton"

const NpsRatingButtonGroupContainer = styled.div`
  margin-bottom: 26px;
  display: flex;
  justify-content: space-around;
  flex-wrap: no-wrap;
  flex-direction: row-reverse;
`

const NpsRatingButtonLabel = styled.span`
  position: absolute;
  top: 100%;
  color: #8a8a8d;
  white-space: nowrap;
  ${props => props.align}: 0;
  margin-top: 8px;
`

const NpsRatingButtonGroup = props => (
  <NpsRatingButtonGroupContainer>
    {props.options.map((option, index) => (
      <NpsRatingButton onClick={() => props.onClick(option.value)} key={index}>
        {option.text}
        {index === 0 ? (
          <NpsRatingButtonLabel align="right">
            {option.text} - Very likely
          </NpsRatingButtonLabel>
        ) : (
          ""
        )}
        {index === props.options.length - 1 ? (
          <NpsRatingButtonLabel align="left">
            {option.text} - Not likely
          </NpsRatingButtonLabel>
        ) : (
          ""
        )}
      </NpsRatingButton>
    ))}
  </NpsRatingButtonGroupContainer>
)

export { NpsRatingButtonGroup as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/nps/NpsRatingButtonGroup.js